import React from "react";

function BS4_Typography() {
  return (
    <div>
      <h1>BS4_Typography Component</h1>
      <p>This is the BS4_Typography tutorial page content.</p>
    </div>
  );
}

export default BS4_Typography;
